import { User } from '../types/userTypes';
import { Project } from '../types/projectTypes';
import axios from 'axios';
import { rols } from '../types/rolsTypes';
import apiClient from './apiClient';

export const getProjects = async (): Promise<Project[]> => {
    try {
        const response = await apiClient.get('/Projects')
        return await response.data;
        //return await response.json();
    } catch (error) {
        const errorMessage = (error as Error).message;
        throw new Error('Error al obtener los proyectos: ' + errorMessage);
    }
};

/**
 * Proyectos de TODOS los países (sin filtrar por el país seleccionado). Se usa en el mantenedor de
 * usuarios para poder resolver los nombres de los proyectos de un usuario aunque sean de otro país.
 */
export const getProjectsAllCountries = async (): Promise<Project[]> => {
    try {
        const response = await apiClient.get('/Projects', { skipCountry: true } as any);
        return await response.data;
    } catch (error) {
        const errorMessage = (error as Error).message;
        throw new Error('Error al obtener los proyectos: ' + errorMessage);
    }
};

export const getUsers = async (): Promise<User[]> => {
    try {
        const response = await apiClient.get('/User')
        return await response.data;
    } catch (error) {
        const errorMessage = (error as Error).message;
        throw new Error('Error al obtener los usuarios: ' + errorMessage);
    }
};

export const getRols = async (): Promise<rols[]> => {
    try{
        const response = await apiClient.get('/rols')
        return await response.data;
    }catch (error){
        const errorMessage = (error as Error).message;
        throw new Error('Error al obtener los roles: ' + errorMessage);
    }
};


export const createUser = async (user: User): Promise<User> => {
    try {
        const response = await apiClient.post("/User", user);
        
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateUser = async (oldRut: string, updatedUser: User): Promise<User> => {
    try {
        const response = await apiClient.put(`/User/${oldRut}`, updatedUser);
        return await response.data;
    } catch (error) {
        if (error instanceof Error) {
            throw new Error('Error al actualizar el usuario: ' + error.message);
        } else {
            throw new Error('Error desconocido al actualizar el usuario');
        }
    }
};

export const deleteUser = async (userId: string): Promise<void> => {
    try {
          await apiClient.post(`/User/delete`, { rut: userId } );
    } catch (error) {
        if (error instanceof Error) {
            throw new Error('Error al intentar eliminar el usuario: ' + error.message);
        } else {
            throw new Error('Error desconocido al intentar eliminar el usuario');
        }
    }
};

export const getProjectsUser = async (identificationNum: string): Promise<number[]> => {
    try {
        const response = await apiClient.post(`/usersProjects/search`,  { rut: identificationNum});
        const data = response.data;

        // Extraer directamente los IDs de los proyectos desde el nivel raíz
        return data.map((project: any) => project.id);
    } catch (error) {
        const errorMessage = (error as Error).message;
        throw new Error('Error al obtener los proyectos: ' + errorMessage);
    }
};

export const getUserProject = async (identificationNum : string): Promise<Project[]> => {
        const response =  await apiClient.post(`/usersProjects/search`, { rut: identificationNum});
        return response.data;
}

export const ProjectsToUser = async (userProject: Object): Promise<void> => {
    try {
        const response = apiClient.post('/usersProjects', userProject)
        return (await response).data;
    } catch (error) {
        throw new Error('Error al asignar proyectos: ' + error);
    }
};

export const updateUserProjects = async (userId: string, projectIds: number[]): Promise<void> => {
    try {
        await apiClient.put(`/usersProjects/update`, { 
                rut: userId,
                projects: projectIds
        });
    } catch (error) {
        throw new Error('Error al actualizar los proyectos: ' + error);
    }
};

export const deleteUserProjects = async (userId: string, projectIds?: number[]): Promise<void> => {
    try {
        await apiClient.post(`/usersProjects/deleteByIdentificationNum`, { rut: userId})
    } catch (error) {
        throw new Error('Error al borrar los proyectos: ' + error);
    }
};

// export const deleteUser = async (userId: string): Promise<void> => {
//     try {
//          await apiClient.delete(`/User`, {
//             data: { rut: userId },
//          });
//     } catch (error) {
//         if (error instanceof Error) {
//             throw new Error('Error al intentar eliminar el usuario: ' + error.message);
//         } else {
//             throw new Error('Error desconocido al intentar eliminar el usuario');
//         }
//     }
// };

export const logout = async (): Promise<void> => {
    try {
        await apiClient.post('/User/logout');

        const loginProvider = localStorage.getItem('loginProvider');

        // Limpiar el frontend
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('loginProvider');

        if (loginProvider === 'azure') {
            const tenantId = "4f7e0e98-323a-422c-8c25-ae67d1a89b77";
            const redirectUri = encodeURIComponent("https://sgrchile-elecnor.duckdns.org/");
            window.location.href = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/logout?post_logout_redirect_uri=${redirectUri}`;
        } else {
        window.location.href = "/";
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error('Error al cerrar sesión: ' + error.message);
        } else {
            throw new Error('Error desconocido al cerrar sesión');
        }
    }
};